import { ICollection } from '@tacans/shared-marketplace-layer';
import Link from 'next/link';
import React from 'react';
import { generatePath, RouteE } from 'src/constants/pages.constants';
import {
    StyledInfoBanner,
    StyledInfoBannerTop,
    StyledInfoBottom,
    StyledPreviewContainer,
    StyledPreviewWrapper,
    StyledWave,
    StyledWaveThree,
    StyledWaveTwo,
} from './collection-card-big.styles';

export interface IProps {
    collection: ICollection;
    testId?: string;
}

export const CollectionCardBig: React.VFC<IProps> = ({ collection, testId }) => {
    const link = generatePath(RouteE.COLLECTION_VIEW, {
        id: collection.id,
    });

    return (
        <Link href={link} prefetch={false}>
            <StyledPreviewContainer data-test-id={testId}>
                <StyledPreviewWrapper>
                    <img src={collection.previewAssets?.originalUrl} alt={collection.name} />
                </StyledPreviewWrapper>
                <StyledInfoBanner>
                    <StyledInfoBannerTop>{collection.name}</StyledInfoBannerTop>
                    <StyledInfoBottom>EXPLORE</StyledInfoBottom>
                </StyledInfoBanner>
                <StyledWave />
                <StyledWaveTwo />
                <StyledWaveThree />
            </StyledPreviewContainer>
        </Link>
    );
};